import { useEffect, useState } from 'react';

import { PaywallProps } from '@components/Paywall';
import { useArticlePaywallProps } from '@hooks';
import { paywallSubject } from '@utils/blueconic/constants';
import { BlueconicPaywallEvent } from '@utils/blueconic/eventsInterfaces';

const useBlueConicPaywallDialogue = ({
  articleId,
  isTwoOptPaywall,
  offerCode,
  shareGuid,
}: Pick<PaywallProps, 'articleId' | 'isTwoOptPaywall' | 'offerCode' | 'shareGuid'>) => {
  const { articlePaywallProps, isArticlePaywallPropsLoading } = useArticlePaywallProps({
    articleId,
    isTwoOptPaywall,
    offerCode,
    shareGuid,
  });

  const [blueConicProps, setBlueConicProps] = useState<PaywallProps | undefined>();

  useEffect(() => {
    const handleBlueconicEvent = (data: BlueconicPaywallEvent) => {
      if (!articlePaywallProps?.paywallProps) return;

      const {
        data: { buttonText, leadType, offerLink, subtitle, title },
      } = data;

      setBlueConicProps({
        ...articlePaywallProps.paywallProps,
        buttonText,
        leadType,
        offerLink,
        subtitle,
        title,
      });
    };
    const subscription = paywallSubject.subscribe(handleBlueconicEvent);

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isArticlePaywallPropsLoading]);

  return {
    paywallProps: blueConicProps ?? articlePaywallProps?.paywallProps,
    isArticlePaywallPropsLoading,
  };
};

export default useBlueConicPaywallDialogue;
